import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CurrencyFormat from "react-currency-format";
import { BIDFORMAT } from "web/components/utils/dateOfBirthValidation";
import Timmer from "web/components/Timmer";
import UploadDummy from "web/assets/images/UploadDummy.png";
import TooltipMaterial from "@material-ui/core/Tooltip";
import * as moment from "moment";
import EditDeleteRecurrence from 'web/components/EditDeleteRecurrence';
import AlertModal from "web/components/AlertModal";
import Button from "web/components/Button";
import styles from "./myPost.module.scss";
import styled from "styled-components";
import Pagination from "web/components/Pagination";
import PalletsSidebar from "web/components/PalletsSidebar";
import Edit from "web/assets/images/edit-icon-1.png";
import Delete from "web/assets/images/delete-icon.png";
import Tooltip from "@material-ui/core/Tooltip";
import RepostModal from "./RepostModal";
import OkCancelAlertModal from "web/components/OkCancelAlertModal";

import { postLoadRepostPopup, } from "redux/actions/postLoad";

//import PalletImage from "web/assets/images/pallet-home-image.webp";
import PalletImage from 'web/assets/images/pallet-home-image.jpg';

import TableRow from "./TableRow";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { fetchLanguageContentNew } from "redux/actions/language";
import { downloadFile } from "redux/actions/helper/downloadFile";
import { stateConvert } from "web/components/utils/stateAbbreviation";

const MyPost = ({
  response,
  totalPageState,
  pageType,
  type,
  isRecurrenceList,
  activePage,
  activeSearch,
  expanded,
  filterArr,
  filterState,
  currentPageNumber,
  deletePost,
  callBackFun,
}) => {
  let history = useHistory();
  const dispatch = useDispatch();

  const token = localStorage.getItem("token");
  let userType = localStorage.getItem("userType");

  const fileUrl = process.env.REACT_APP_API_URL + "/user/image/";

  const [repostBidModal, setRepostBidModal] = useState(false);
  const toggleRepostBidModal = () => setRepostBidModal(!repostBidModal);
  const [repostSelectedIem, setRepostSelectedIem] = useState();

  const [recurrenceActionType, setRecurrenceActionType] = useState('');
  const [editDeleteRecurrenceItem, setEditDeleteRecurrenceItem] = useState();
  const [editDeleteModal, setEditDeleteModal] = useState(false);
  const editDeleteModalToggleModal = () => setEditDeleteModal(!editDeleteModal);

  let daysOfWeek = [];
  if (
    response &&
    response.recurrence &&
    response.recurrence.pattern &&
    (response.recurrence.pattern.type === "WEEKLY" ||
      response.recurrence.pattern.type === "RELATIVEMONTHLY" ||
      response.recurrence.pattern.type === "MONTHLY")
  ) {
    for (let i = 0; i < response.recurrence.pattern.daysOfWeek.length; i++) {
      if (response.recurrence.pattern.daysOfWeek[i] === "MONDAY") {
        daysOfWeek.push("M");
      }
      if (response.recurrence.pattern.daysOfWeek[i] === "TUESDAY") {
        daysOfWeek.push(" T");
      }
      if (response.recurrence.pattern.daysOfWeek[i] === "WEDNESDAY") {
        daysOfWeek.push(" W");
      }
      if (response.recurrence.pattern.daysOfWeek[i] === "THURSDAY") {
        daysOfWeek.push(" Th");
      }
      if (response.recurrence.pattern.daysOfWeek[i] === "FRIDAY") {
        daysOfWeek.push(" F");
      }
      if (response.recurrence.pattern.daysOfWeek[i] === "SATURDAY") {
        daysOfWeek.push(" Sat");
      }
      if (response.recurrence.pattern.daysOfWeek[i] === "SUNDAY") {
        daysOfWeek.push(" Sun");
      }
    }
  }
  if (
    response &&
    response.postRecurrence &&
    response.postRecurrence.pattern &&
    (response.postRecurrence.pattern.type === "WEEKLY" ||
      response.postRecurrence.pattern.type === "RELATIVEMONTHLY" ||
      response.postRecurrence.pattern.type === "MONTHLY")
  ) {
    for (
      let i = 0;
      i < response.postRecurrence.pattern.daysOfWeek.length;
      i++
    ) {
      if (response.postRecurrence.pattern.daysOfWeek[i] === "MONDAY") {
        daysOfWeek.push("M");
      }
      if (response.postRecurrence.pattern.daysOfWeek[i] === "TUESDAY") {
        daysOfWeek.push(" T");
      }
      if (response.postRecurrence.pattern.daysOfWeek[i] === "WEDNESDAY") {
        daysOfWeek.push(" W");
      }
      if (response.postRecurrence.pattern.daysOfWeek[i] === "THURSDAY") {
        daysOfWeek.push(" Th");
      }
      if (response.postRecurrence.pattern.daysOfWeek[i] === "FRIDAY") {
        daysOfWeek.push(" F");
      }
      if (response.postRecurrence.pattern.daysOfWeek[i] === "SATURDAY") {
        daysOfWeek.push(" Sat");
      }
      if (response.postRecurrence.pattern.daysOfWeek[i] === "SUNDAY") {
        daysOfWeek.push(" Sun");
      }
    }
  }

  const [alertType, setAlertType] = useState();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [modalLink, setModalLink] = useState("");
  const toggleModal = () => setModal(!modal);
  let title = "";

  const [okCancelModal, setOkCancelModal] = useState(false);
  const [okCancelModalContent, setOkCancelModalContent] = useState("");
  const toggleOkCancelModal = () => setOkCancelModal(!okCancelModal);
  const [deleteID, setDeleteID] = useState("");

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => { }, [currentLanguage]);

  useEffect(() => {
    if (languageContentNew?.PostedOffers_Page) setPageLanguageContents(languageContentNew.PostedOffers_Page);
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  const [setTimer, setTimerState] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      history.push("/sign-in");
      window.location.reload(false);
    } else {
      setTimerState(false);
      setTimeout(() => {
        if (!response || (response && response.length === 0))
          setTimerState(true);
      }, 2000);
    }
  }, [response]);

  const [sortState, setSortState] = useState("DESC");

  const onPageChange = async (pageNumber) => {
    callBackFun(pageNumber, sortState, userType);
  };

  const detailPageRedirect = (items, index) => {
    let obj = {
      id: items.postId?.toString(),
      postType: 'PostLoad',
    }
    dispatch({ type: 'DETAILS', payload: obj })
    history.push({
      pathname: '/details',
    })
  };
  const repostBidApi = async (
    items,
    date,
    pickupStartTime,
    pickupEndTime,
    setBidTime,
    bidCloseDate,
    rePostBidCloseTime
  ) => {
    if (token === null) {
      setModalContent("Please Sign In again.");
      setModalLink("/");
      toggleModal();
    } else {
      let response
      if (items?.shippingMode === "PICKUP") {
        let data = {
          // appointmentStartTime: pickupStartTime,
          // appointmentEndTime: pickupEndTime,
          requestedDate: moment(date).format(BIDFORMAT),
          bidCloseTime: bidCloseDate + "T" + rePostBidCloseTime,
          id: items?.postId,
          authId: localStorage.getItem('authId'),
        };
        response = await dispatch(postLoadRepostPopup(data, token));
      } else {
        let data = {
          appointmentStartTime: pickupStartTime,
          appointmentEndTime: pickupEndTime,
          requestedDate: moment(date).format(BIDFORMAT),
          bidCloseTime: bidCloseDate + "T" + rePostBidCloseTime,
          id: items?.postId,
          authId: localStorage.getItem('authId'),
        };
        response = await dispatch(postLoadRepostPopup(data, token));
      }

      if (response?.success) {
        setAlertType("Repost");
        toggleRepostBidModal();
        setModalContent(response?.data?.msg)
        setModalLink("");
        toggleModal();
        // window.location.reload(false);
      } else {
        if (response?.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in');
          window.location.reload(false);
        } else {
          setModalContent(response?.data?.error?.message || response?.data?.message || response?.message || 'Something went wrong, please try again in some time.');
          setModalLink("");
          toggleModal();
        }
      }
    }
  };

  const recurrenceTag = (items) => {
    let dayOfWeekVal = "";
    if (items.pattern?.dayOfWeek) {
      if (items.pattern.dayOfWeek === "MONDAY") dayOfWeekVal = "M";
      if (items.pattern.dayOfWeek === "TUESDAY") dayOfWeekVal = " T";
      if (items.pattern.dayOfWeek === "WEDNESDAY") dayOfWeekVal = " W";
      if (items.pattern.dayOfWeek === "THURSDAY") dayOfWeekVal = " Th";
      if (items.pattern.dayOfWeek === "FRIDAY") dayOfWeekVal = " F";
      if (items.pattern.dayOfWeek === "SATURDAY") dayOfWeekVal = " Sat";
      if (items.pattern.dayOfWeek === "SUNDAY") dayOfWeekVal = " Sun";
    }
    daysOfWeek = [];
    if (items.pattern && (items.pattern.type === "WEEKLY" || items.pattern.type === "RELATIVEMONTHLY" || items.pattern.type === "MONTHLY")) {
      for (let i = 0; i < items.pattern.daysOfWeek.length; i++) {
        if (items.pattern.daysOfWeek[i] === "MONDAY") daysOfWeek.push("M")
        if (items.pattern.daysOfWeek[i] === "TUESDAY") daysOfWeek.push(" T")
        if (items.pattern.daysOfWeek[i] === "WEDNESDAY") daysOfWeek.push(" W")
        if (items.pattern.daysOfWeek[i] === "THURSDAY") daysOfWeek.push(" Th")
        if (items.pattern.daysOfWeek[i] === "FRIDAY") daysOfWeek.push(" F")
        if (items.pattern.daysOfWeek[i] === "SATURDAY") daysOfWeek.push(" Sat")
        if (items.pattern.daysOfWeek[i] === "SUNDAY") daysOfWeek.push(" Sun")
      }
    }

    if (items.pattern) {
      return (
        <TimeSection>
          <>
            <div className="flow-column">
              {items.pattern.type === "DAILY" && (
                <span>
                  Daily,&nbsp;
                  <>
                    {"Starting  " + moment(items.range.start).format("MM/DD/YYYY")},{" "}
                    {"Ending " + moment(items.range.endBy).format("MM/DD/YYYY")}
                  </>
                </span>
              )}
              {items.pattern.type === "WEEKLY" && (
                <span>
                  Weekly,&nbsp;Every {daysOfWeek.join(",")},&nbsp;
                  <>
                    {"Starting  " + moment(items.range.start).format("MM/DD/YYYY")},{" "}
                    {"Ending " + moment(items.range.endBy).format("MM/DD/YYYY")}
                  </>
                </span>
              )}
              {items.pattern.type === "MONTHLY" && (
                <span>
                  Monthly,&nbsp;
                  {daysOfWeek.length !== 0 && <>Every {daysOfWeek.join(",")}</>}
                  &nbsp;
                  <>
                    {"Starting  " + moment(items.range.start).format("MM/DD/YYYY")},{" "}
                    {"Ending " + moment(items.range.endBy).format("MM/DD/YYYY")}
                  </>
                </span>
              )}
              {items.pattern.type === "RELATIVEMONTHLY" && (
                <span>
                  Monthly,&nbsp;
                  {items.pattern.dayOfWeek && (<>Every {dayOfWeekVal}</>)}
                  &nbsp;
                  <>
                    {"Starting  " + moment(items.range.start).format("MM/DD/YYYY")},{" "}
                    {"Ending " + moment(items.range.endBy).format("MM/DD/YYYY")}
                  </>
                </span>
              )}
            </div>
          </>
        </TimeSection>
      );
    }
  };
  const generatePdfDocument = async (imagePath) => {
    // const fileUrl = process.env.REACT_APP_API_URL + "/order/image/" + imagePath;
    // window.open(fileUrl);
    dispatch(downloadFile(imagePath));
  };
  const [expanded1, setExpanded1] = useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded1(isExpanded ? panel : false);
  };

  const capitalizeFirstLetter = (input) => {
    if (input) return input[0].toUpperCase() + input.slice(1).toLowerCase();
  }

  const capitalize = (s) => {
    if (typeof s !== 'string')
      return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  const headerContent = (items, index) => {
    //pallet details string creation
    let palletDetailsString
    if (items.palletDetails?.material) palletDetailsString = capitalize(items.palletDetails?.material.toLowerCase())
    if (items.palletDetails?.condition) palletDetailsString = capitalize(palletDetailsString.toLowerCase()) + ', ' + (items.palletDetails?.condition[0] === 'Recycled' ? 'Used' : capitalize(items.palletDetails?.condition[0].toLowerCase()))
    if (items.palletDetails?.newConditionType && items.palletDetails?.newConditionType !== '') palletDetailsString = palletDetailsString + (items.palletDetails?.newConditionType === 'HARDWOOD' ? ' (HW)' : ' (SW)')
    if (items.palletDetails?.palletType && items.palletDetails?.palletType !== '') palletDetailsString = palletDetailsString + ', ' + (items.palletDetails?.palletType === 'EUROPALLET' ? 'Euro Pallet' : capitalizeFirstLetter(items.palletDetails?.palletType))
    if (items.palletDetails?.size && items.palletDetails?.size !== '' && items.palletDetails?.size !== 'Custom') palletDetailsString = palletDetailsString + ', ' + items.palletDetails?.size
    if (items.palletDetails?.length && items.palletDetails?.length !== '') palletDetailsString = palletDetailsString + ', ' + `${items.palletDetails?.length}x${items.palletDetails?.width}x${items.palletDetails?.height}`

    return (
      <>
        <div className="product-block post-accordion">
          <Accordion
            expanded1={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <div
                className={pageType === "PostLoad" ? "community-details-header seller" : "community-details-headerSeller seller"}
              >
                <div className={`first-section ${isRecurrenceList ? 'recurringList' : ''}`}>
                  <h6>
                    <Tooltip
                      placement="top"
                      arrow
                      title={items.postTitle || items.postName}
                      enterTouchDelay={0}
                    >
                      <a onClick={(e) => detailPageRedirect(items, index)}>{items.postTitle || items.postName}</a>
                    </Tooltip>
                  </h6>
                  <p>({items.city?.trim() || items?.shippingAddress?.city?.trim()}, {items.stateAbr || stateConvert(items?.shippingAddress?.state)})</p>
                  {items?.orderRecurrence && <span className={styles.recurrence}>Recurring Order</span>}
                  {items?.postRecurrence && <span className={styles.recurrence}>Recurring Post</span>}
                </div>
                <div className={`heading-actions web-view-heading-action ${isRecurrenceList ? 'recurringList' : ''}`}>
                  <div>
                    {(items.bidCloseTime - Date.now() / 1000 < 0 || items.status === 'EXPIRED') && items.isActive && items?.bidDetails.length === 0 && !items.postRecurrence && !items.orderRecurrence && <>
                      <div className="repost">
                        <Button
                          type="app-green-button"
                          title="Repost"
                          handleClick={() => {
                            toggleRepostBidModal();
                            setRepostSelectedIem(items);
                          }}
                        >
                          {pageLanguageContents?.Contents[12]?.Repost}
                        </Button>
                      </div>
                    </>}

                    {items.bidCloseTime - Date.now() / 1000 > 0 && items.isActive && items.status !== 'ACCEPTED' && items.status !== 'EXPIRED' &&
                      <p className="timer">
                        <Timmer
                          time={items.bidCloseTime - Math.trunc(Date.now() / 1000)}
                        />
                      </p>
                    }
                  </div>

                  <div className="edit-section">
                    {(items.status === 'AVAILABLE' && items?.bidDetails?.length === 0 && items.isActive && !items.postRecurrence && !items.orderRecurrence) && items.bidCloseTime - Date.now() / 1000 > 0 && (
                      <div>
                        <Button
                          type="icon-btn"
                          disabled={!true}
                          title="Edit Post"
                          handleClick={() => {
                            let obj = {
                              postType: "PostLoad",
                              id: items.postId.toString(),
                              expanded: "panel1",
                              activePage: "PostLoad",
                            };
                            dispatch({
                              type: "POST_LOAD_URL",
                              payload: obj,
                            });
                            let obj2 = { selectedPage: currentPageNumber, };
                            dispatch({ type: "BIDS_PAGINATION", payload: obj2 });
                            history.push({
                              pathname: "/post-my-pallet-needs",
                            });
                          }}
                        >
                          <img src={Edit} className="icon" alt="Edit" />
                        </Button>
                      </div>
                    )}
                    {/* {items.status === 'AVAILABLE' && items?.bidDetails.length ===0 && ( */}
                    {items?.bidDetails?.length === 0 && items.isActive && !isRecurrenceList && (
                      <div>
                        <Button
                          type="icon-btn"
                          disabled={!true}
                          handleClick={() => {
                            let obj = { selectedPage: currentPageNumber, };
                            dispatch({ type: "BIDS_PAGINATION", payload: obj });
                            setDeleteID(items.postId);
                            setOkCancelModalContent("Are you sure you want to delete this post?");
                            setOkCancelModal(true);
                          }}
                          title="Delete Post"
                        >
                          <img src={Delete} className="icon delete-icon" alt="Delete" />
                        </Button>
                      </div>
                    )}

                    {isRecurrenceList &&
                      <div>
                        <Button
                          type="icon-btn"
                          disabled={!true}
                          handleClick={() => {
                            let obj = { selectedPage: currentPageNumber, };
                            dispatch({ type: "BIDS_PAGINATION", payload: obj });
                            setEditDeleteRecurrenceItem(items)
                            setRecurrenceActionType('EDIT')
                            editDeleteModalToggleModal()
                          }}
                          title="Edit Post"
                        >
                          <img src={Edit} className="icon edit-icon" alt="Edit" />
                        </Button>
                      </div>}
                      
                    {!items.isActive && !isRecurrenceList  && filterState !== 'AVAILABLE' && <span className={styles.recurrence}>Deleted</span>}

                    {items.status !== 'AVAILABLE' && items.isActive && <span className={styles.recurrence}>{items?.status}</span>}
                    {!isRecurrenceList && <p className={items.bidDetails?.length > 0 ? "bids-count" : "bids-zero"}>{items.bidDetails?.length}</p>}
                  </div>
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className="product-block-details">
                <div
                  className={pageType === "PostLoad" ? "product-block-imgDarkBlue" : "product-block-img"}
                  onClick={(e) => detailPageRedirect(items, index)}
                >
                  <div className="pallete-image p-2 web-view">
                    <img
                      style={{cursor: 'pointer'}}
                      src={items.postImageFiles && items.postImageFiles.length > 0 ? `${fileUrl}${items.postImageFiles[0].fileName}` : PalletImage}
                      alt='img'
                    />
                  </div>
                </div>

                <div className="product-block-description mypostload">
                  <div className="product-block-rows border-bottom">
                    <div className="row">
                      <div className="col-50 text-bold">
                        <p>{pageLanguageContents?.Contents[15]?.TargetPrice}</p>
                      </div>
                      <div className="col-50">
                        <span>
                          {(items.targetPrice && items.targetPrice > 0) ?
                            <>
                              <CurrencyFormat
                                value={items.targetPrice.toFixed(2)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix={"$"}
                              />
                              &nbsp;<small>{pageLanguageContents?.Contents[16]?.PerPallet}</small>
                            </>
                            : 'NA'}
                        </span>
                      </div>
                    </div>
                    {!isRecurrenceList &&
                      <div className="row">
                        <div className="col-50 text-bold">
                          <p>{pageLanguageContents?.Contents[17]?.PostStatus}</p>
                        </div>
                        <div className="col-50">
                          <span>{capitalizeFirstLetter(items.status || '')}</span>
                        </div>
                      </div>
                    }
                    <div className="row">
                      <div className="col-50 text-bold">
                        <p>{pageLanguageContents?.Contents[18]?.PostedTo}</p>
                      </div>
                      <div className="col-50">
                        <span>{items.postingMethod === 'MARKET' ? 'Marketplace' : capitalizeFirstLetter(items.postingMethod || '')}</span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-50 text-bold">
                        <p>{pageLanguageContents?.Contents[21]?.Quantity}</p>
                      </div>
                      <div className="col-50">
                        <span>
                          {items.lotDetails?.lotPostingOption === 'SINGLE' ? items.lotDetails?.totalQty.toLocaleString() : items.lotDetails?.qtyPerLot.toLocaleString()}&nbsp;
                          <span className={styles.Lots}>
                            {items.lotDetails?.lotPostingOption === 'SINGLE' ? (
                              <>
                                {" "}
                                ({items.lotDetails?.totLots}{" "}
                                {pageLanguageContents?.Contents[22]?.Lot}s)
                              </>
                            ) : (
                              <></>
                            )}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-50 text-bold web-view">
                        {items.shippingMode === 'DELIVERY' ? <p>Requested Delivery Date:</p> : <p>Requested PU Date:</p>}
                      </div>
                      <div className="col-50 text-bold mobile-view">
                        {items.shippingMode === 'DELIVERY' ? <p>Req Del Date:</p> : <p>Req PU Date:</p>}
                      </div>
                      <div className="col-50">
                        {/* <span>{moment(items.requestedDate * 1000).format("MM/DD/YYYY")}</span> */}
                        <span>{moment(items?.requestedDate).format("MM/DD/YYYY")}</span>
                      </div>
                    </div>

                    {items?.ptPlusDetails?.orderRefNumber &&
                      <div className="row">
                        <div className="col-50 text-bold">
                          <p>Order Reference Number:</p>
                        </div>
                        <div className="col-50" style={{ "white-space": "nowrap", "overflow": "hidden", "text-overflow": "ellipsis" }}>
                          <span>
                            <TooltipMaterial
                              placement="top"
                              arrow
                              title={items?.ptPlusDetails?.orderRefNumber}
                              enterTouchDelay={0}
                            >
                              <span>{items?.ptPlusDetails?.orderRefNumber}</span>
                            </TooltipMaterial>
                          </span>
                        </div>
                      </div>
                    }
                    {items?.postRecurrence ?
                      <div className="row">
                        <div className="col-50 text-bold">
                          <p>Recurring Post Requirements:</p>
                        </div>
                        <div className="col-50">
                          <span>{recurrenceTag(items?.postRecurrence)}</span>
                        </div>
                      </div> :
                      items?.orderRecurrence ?
                        <div className="row">
                          <div className="col-50 text-bold">
                            <p>Recurring Order Requirements:</p>
                          </div>
                          <div className="col-50">
                            <span>{recurrenceTag(items?.orderRecurrence)}</span>
                          </div>
                        </div> : ''}

                    <div className="row">
                      {/* {items.bidCloseTime - Date.now() / 1000 > 0 && */}
                      {items.bidCloseTime - Date.now() / 1000 > 0 && items.isActive && items.status !== 'ACCEPTED' && items.status !== 'EXPIRED' &&
                        <>
                          <div className="col-50 text-bold">
                            <p>Time Left:</p>
                          </div>
                          <div className="col-50">
                            <span>{<Timmer time={items.bidCloseTime - Math.trunc(Date.now() / 1000)} />}</span>
                          </div>
                        </>
                      }
                    </div>
                  </div>
                  <div className="product-block-rows">
                    <div className="row">
                      <h5 style={{ wordBreak: "break-all" }}>
                        {items.comments}
                      </h5>
                    </div>
                    <div className="row">
                      <div className="col-50 text-bold">
                        <p>Post Details:</p>
                      </div>
                      <div className="col-50">
                        <p>{palletDetailsString}</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-50 text-bold">
                        <p>Grade:</p>
                      </div>
                      <div className="col-50">
                        <p>{(items.palletDetails?.grade && items.palletDetails?.grade !== '') ? items.palletDetails?.grade : 'NA'}</p>
                      </div>
                    </div>

                    <div className="row upload-wrapper">
                      {items.specificationFiles && items.specificationFiles.map((spectItems, i) => (
                        <div
                          className="upload"
                          style={{ "cursor": "pointer" }}
                          onClick={() => generatePdfDocument(spectItems.fileName)}
                        >
                          <img
                            style={{ marginRight: "5px" }}
                            src={UploadDummy}
                            alt="upload Dummy"
                          />
                          <Tooltip
                            placement="top"
                            arrow
                            title={spectItems.orignalFileName}
                            enterTouchDelay={0}
                          >
                            <span>{spectItems.orignalFileName}</span>
                          </Tooltip>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {!isRecurrenceList &&
                  <div className="post-table">
                    <TableRow
                      pageLanguageContents={pageLanguageContents}
                      response={items}
                      currentPageNumber={currentPageNumber}
                      callBackFetchApi={() => callBackFun(currentPageNumber)}
                    />
                  </div>
                }
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </>
    );
  };
  return (
    <>
      <div className="custom-wrapper-myPost">
        <div className="pd-right-nav">
          {activePage && (
            <PalletsSidebar
              postType={type}
              activePage={activePage}
              expandedPallet={expanded}
              activeSearch={activeSearch}
            />
          )}
        </div>
        <div className="left-content">
          {response && response?.length !== 0 ? (
            <>
              {response.map((items, index) => (
                <>
                  <div key={index} className="j1">
                    <>{headerContent(items, index)}</>
                  </div>
                </>
              ))}
            </>
          ) : (
            <>
              {setTimer && (
                <div className={styles.noRecordFound}>
                  {pageLanguageContents?.Contents[26]?.NoRecord}
                </div>
              )}
            </>
          )}
          {totalPageState && response && (
            <Pagination
              currentPage={currentPageNumber}
              totalPage={totalPageState}
              itemsCountPerPage={10}
              onPageChange={(value) => {
                onPageChange(value);
              }}
            />
          )}

          {repostSelectedIem && (
            <RepostModal
              isOpen={repostBidModal}
              toggle={toggleRepostBidModal}
              response={repostSelectedIem}
              title={"Repost"}
              link="/"
              myPostType={pageType}
              repostCallBack={(
                date,
                pickupStartTime,
                pickupEndTime,
                setBidTime,
                bidCloseDate,
                rePostBidCloseTime
              ) => {
                repostBidApi(
                  repostSelectedIem,
                  date,
                  pickupStartTime,
                  pickupEndTime,
                  setBidTime,
                  bidCloseDate,
                  rePostBidCloseTime
                );
              }}
            />
          )}
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={title}
            content={modalContent}
            link={modalLink}
            alertType={alertType}
            callBackAlert={(val) => {
              if (val === "Repost") {
                callBackFun(
                  currentPageNumber,
                  sortState,
                  userType,
                  "",
                  "repost"
                );
              }
            }}
          />

          {editDeleteRecurrenceItem &&
            <EditDeleteRecurrence
              isOpen={editDeleteModal}
              toggle={editDeleteModalToggleModal}
              title=""              
              postType='Need'
              actionType={recurrenceActionType}
              items={editDeleteRecurrenceItem}
              callBackFun={(obj) => {
                editDeleteModalToggleModal()
                callBackFun(currentPageNumber, '', '', 'editDeleteRecurrence', '')
              }}
            />}

          <OkCancelAlertModal
            isOpen={okCancelModal}
            toggle={toggleOkCancelModal}
            alertType="postDelete"
            content={okCancelModalContent}
            callBackAlert={() => {
              deletePost(deleteID);
            }}
          />
        </div>
      </div>
    </>
  );
};
export default MyPost;

const ShowDetailSection = styled.div`
  .MuiAccordionDetails-root {
    > p {
      width: 100%;
    }
  }
`;
const TimeSection = styled.div`
  display: grid;
  grid-auto-flow: column;
  padding: 0;
  background: #fff;
  @media (max-width: 767px) {
    padding-bottom: 0;
    grid-auto-flow: unset;
    gap: 10px;
  }
  h3 {
    font-size: 16px;
    font-family: "latosemibold";
  }
  p {
    font-size: 12px;
    font-family: "latoregular";
    color: #717171;
    margin: 0;
    line-height: 27px;
  }
  & > div {
    display: flex;
    @media (max-width: 767px) {
      display: grid;
      grid-template-columns: 30px 1fr;
      gap: 10px;
      &.flow-column {
        grid-template-columns: 1fr 1fr;
        h3 {
          order: 2;
          font-size: 16px;
        }
        p {
          font-size: 16px;
          line-height: 1;
        }
      }
    }
    &.flow-column {
      flex-direction: column;
    }
    .icon-col {
      width: 26px;
      margin-right: 8px;
      &.distance-col {
        max-width: 18px;
      }
      img {
        max-width: 100%;
      }
    }
    .d-text {
      max-width: 190px;
      @media (max-width: 767px) {
        max-width: none;
      }
    }
  }
  @media (max-width: 767px) {
    h3 {
      font-size: 20px;
    }
    p {
      font-size: 13px;
    }
  }
`;
